module.exports = __webpack_public_path__ + "static/media/0176_Small.c61dba37.jpg";